import { deleteAttachment } from 'api/Attachments';
import { deleteResponse } from 'api/CustomForms';
import { deleteDocument } from 'api/Documents';
import { deleteFax } from 'api/Fax';

import { showAlert } from 'components/shared/Alert/Alert';

import setMultipleQueriesData from '../setMultipeQueriesData';

export default async function handleDeletion({
  type,
  id,
  navigate,
  queryClient,
  setDeleteLoading,
  currentFile,
  setShowConfirmation,
  appointmentId,
  setCurrentFile,
  initConfirmation
}) {
  setDeleteLoading(true);

  const getData = async () => {
    if (appointmentId) {
      return deleteAttachment(navigate, {
        ...currentFile,
        appointmentId
      });
    }
    switch (type) {
      case 'patient_documents':
        return deleteDocument(navigate, { handle: id });
      case 'form_response_store':
        return deleteResponse(navigate, { id });
      case 'fax':
        return deleteFax(navigate, id);

      default:
        showAlert({ title: 'There was a problem while deleting document.', color: 'danger' });
        return null;
    }
  };

  const data = await getData();

  if (data?.deleted || data?.data > 0 || (data?.code === 0 && type === 'fax')) {
    showAlert({
      title: `${currentFile?.name} ${currentFile.deleteInstances || !appointmentId ? 'deleted' : 'removed from note'} successfully`,
      color: 'success'
    });

    if (currentFile.deleteInstances || !appointmentId) {
      setMultipleQueriesData(
        queryClient,
        [
          'practice-documents',
          ['chart-documents', currentFile?.patient_id],
          [
            'attachment-documents',
            appointmentId?.toString() || currentFile?.appointment_id?.toString()
          ]
        ],
        (old) => {
          return {
            ...old,
            documents: old?.documents?.filter((item) =>
              typeof id === 'string' ? item.document_handle !== id : item?.id !== id
            )
          };
        }
      );
    } else {
      setMultipleQueriesData(
        queryClient,
        [
          'practice-documents',
          ['chart-documents', currentFile?.patient_id],
          ['attachment-documents', currentFile?.appointment_id?.toString()]
        ],
        (old) => {
          return {
            ...old,
            documents: currentFile.deleteInstances
              ? old?.documents?.filter((item) =>
                  typeof id === 'string' ? item.document_handle !== id : item?.id !== id
                )
              : old?.documents?.map((item) => {
                  if (typeof id === 'string' ? item.document_handle === id : item?.id === id) {
                    return {
                      ...item,
                      appointment_id: null,
                      date_of_service: null
                    };
                  } else {
                    return item;
                  }
                })
          };
        }
      );

      queryClient.setQueriesData(
        [
          'attachment-documents',
          appointmentId?.toString() || currentFile?.appointment_id?.toString()
        ],
        (old) => {
          return {
            ...old,
            documents: old?.documents?.filter((item) =>
              typeof id === 'string' ? item.document_handle !== id : item?.id !== id
            )
          };
        }
      );
    }

    setShowConfirmation(initConfirmation);
  } else {
    showAlert({ title: 'There was a problem while deleting document.', color: 'danger' });
  }
  setCurrentFile(null);
  setDeleteLoading(false);
}
